import classNames from 'classnames'
import * as React from 'react'
import { Area as RechartsArea } from 'recharts'

import { LineDot } from './LineDot'
import { CHART_ITEM_COLORS, ChartItemColorType } from './constants'

interface AreaGradientProps {
  id: string
  color: ChartItemColorType
}

export function AreaGradient({ id, color }: AreaGradientProps) {
  const gradientColor = CHART_ITEM_COLORS[color] ?? CHART_ITEM_COLORS.blue

  return (
    <linearGradient id={id} x1="0" y1="0" x2="0" y2="1" className={gradientColor}>
      <stop offset="5%" stopOpacity={0.5} className="[stop-color:currentColor]" />
      <stop offset="95%" stopOpacity={0} className="[stop-color:currentColor]" />
    </linearGradient>
  )
}

interface AreaProps extends React.PropsWithoutRef<React.ComponentProps<typeof RechartsArea>> {
  color?: ChartItemColorType
}

export class Area extends React.Component<AreaProps> {
  static getComposedData = RechartsArea.getComposedData
  static displayName = RechartsArea.displayName

  static defaultProps = {
    ...RechartsArea.defaultProps,
    type: 'linear',
    dot: <LineDot className="opacity-50" />,
    activeDot: false,
    isAnimationActive: false,
    connectNulls: false,
    stroke: null,
    fill: null,
  }

  render() {
    const { color = 'blue', ...props } = this.props

    return (
      <RechartsArea
        {...props}
        stroke={null as any}
        className={classNames(props.className, 'fill-current stroke-current', CHART_ITEM_COLORS[color])}
      />
    )
  }
}
